import styled from 'styled-components';
import { AppBar, Toolbar, Button, IconButton, Tooltip } from '@mui/material';

const onDesktop = (selectors) => `
@media (min-width: 992px) {
  ${selectors}
}
`;

export const StyledAppBar = styled(AppBar)`
  && {
    background-color: white;
    color: #333;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    border-bottom: 1px solid #e0e0e0;
  }
`;

export const StyledToolbar = styled(Toolbar)`
  && {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    min-height: 64px;
    height:66px;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LogoText = styled.span`
  font-size: 24px;
  font-weight: bold;
  color: #333;
`;

export const LogoImage = styled.img`
    width: 14vh;
    min-width: 68px;
    height: 5vh;
    min-height: 29px;
    margin: 0.6rem 20px;
`;


export const VerticalSeparator = styled.ul`
    display: none;
    padding-left: 1vh;
    margin-left: 1vh;
    margin-top: 12px;
    border-left: 1px solid #e7e7e7;
    margin-bottom: 10px;
    vertical-align: top;
    height: 6vh;
    ${onDesktop(`
      display: inline-block !important;
    `)}
`;

export const NavigationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 1;
  justify-content: center;
`;

export const NavigationBar = styled.div`
  background-color: white;
  border-bottom: 1px solid #e0e0e0;
  padding: 12px 16px;
  display: ${props => props.show ? 'flex' : 'none'};
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 24px;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
`;

export const NavButton = styled(Button)`
  && {
    color: #666;
    text-transform: none;
    font-size: 14px;
    font-weight: 400;
    padding: 8px 12px;
    display: flex;
    flex-direction: row;
    gap: 7px;
    margin-bottom: 4px;
    height:66px;
    
    &:hover {
      background-color: rgba(0,0,0,0.04);
      color:  #80bd01;
      border-bottom: 4px solid #80bd01;
      margin-bottom: 0;
      border-radius: 0;
    }
  }
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const CuadreButton = styled(Button)`
  && {
    background-color: #c8c8c8;
    color: white;
    text-transform: none;
    font-size: 13px;
    padding: 6px 12px;
    font-weight: 700;
    border-radius: 4px;
    box-shadow: none;
    
    &:hover {
      background-color: #d0d0d0;
      box-shadow: none;
    }
  }
`;

export const LanguageButton = styled(Button)`
  && {
    background-color: #9e9e9e;
    color: white;
    text-transform: none;
    font-size: 12px;
    font-weight: bold;
    padding: 6px 12px;
    border-radius: 4px;
    min-width: auto;
    
    &:hover {
      background-color: #757575;
    }
  }
`;

export const MenuButton = styled(IconButton)`
  && {
    color:#a1a1a1;
    font-size: 29px
  }
`;

export const ToggleMenuButton = styled(Button)`
  && {
    color:#a1a1a1;
    text-transform: none;
    font-size: 14px;
    padding: 4px 8px;
    display: none;
    
    &:hover {
      background-color: rgba(0,0,0,0.04);
    }
    ${onDesktop(`
      display: flex !important;
    `)}
  }
`;

export const MobileToggleMenuButton = styled(Button)`
  && {
      padding: .25rem .75rem;
    font-size: 1.25rem;
    line-height: 1;
    background-color: transparent;
    border: 1px solid transparent;
    color: rgba(0, 0, 0, .5);
    border-color: rgba(0, 0, 0, .1);
    border-radius: .25rem;
    display: flex;
    height: 66px;
    margin-left: -16px;
    cursor: pointer;
   
    ${onDesktop(`
      display:none;
    `)}
  }
`;

export const ProfileButton = styled(Button)`
 &&{
    color: #a1a1a1;
    text-transform: none;
    font-size: 20px;
    font-weight: 400;
    padding: 8px 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;
    h6{
         color: #a1a1a1;
         font-weight: 400;
    }
      svg{
         color: #a1a1a1;
    }
    
    &:hover {
    
    }
 }
`
